var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLayoutCompact = function SvgLayoutCompact(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2608757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 78 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.5C15 10.0523 14.5523 10.5 14 10.5H2C1.44772 10.5 1 10.0523 1 9.5C1 8.94772 1.44772 8.5 2 8.5H14C14.5523 8.5 15 8.94772 15 9.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 80 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.5C15 4.05228 14.5523 4.5 14 4.5H2C1.44772 4.5 1 4.05228 1 3.5C1 2.94772 1.44772 2.5 2 2.5H14C14.5523 2.5 15 2.94772 15 3.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 79 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12.5C15 13.0523 14.5523 13.5 14 13.5H2C1.44772 13.5 1 13.0523 1 12.5C1 11.9477 1.44772 11.5 2 11.5H14C14.5523 11.5 15 11.9477 15 12.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 81 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6.5C15 7.05228 14.5523 7.5 14 7.5H2C1.44772 7.5 1 7.05228 1 6.5C1 5.94772 1.44772 5.5 2 5.5H14C14.5523 5.5 15 5.94772 15 6.5Z",
    fill: "currentColor"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLayoutCompact);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/layout-compact.7d6528a920858024cb5c91e718d6e299.svg";